import React from 'react';
import { Autocomplete, Popper, TextField } from '@mui/material';
import { Box } from '@mui/material';
import { ErrorMessage, useField } from 'formik';

const CustomMonoIdAutocomplete = ({
    formik,
    label,
    color,
    children,
    handler,
    options,
    defaultOption,
    popperPlacement,
    popperWidth,
    ...props
}) => {
    const [field, meta] = useField(props);
    const [value, setValue] = React.useState(
        defaultOption ? defaultOption : undefined,
    );
    const [inputValue, setInputValue] = React.useState('');

    const handleChange = (payload) => {
        const fieldName = field.name;
        formik.setFieldValue(`${fieldName}`, payload);
        // -> Handler
        handler && handler(payload);
    };

    return (
        <>
            <Box
                sx={{
                    borderRadius: 1.5,
                    width: '100%',
                    position: 'relative',
                }}
            >
                <Autocomplete
                    // value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        handleChange(newValue.id);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    options={options ? options : []}
                    size={'small'}
                    sx={{ color: `${color ? color : '#eee'}` }}
                    isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            {...field}
                            {...props}
                            label={label}
                            variant="filled"
                        />
                    )}
                />
                <ErrorMessage
                    component="span"
                    name={field.name}
                    className="error-text"
                />
            </Box>
        </>
    );
};

export default CustomMonoIdAutocomplete;
